import { Navigate, useLocation } from "react-router-dom";
import { canAccessPath } from "../../../utils/userPermissions";
import { isFranchisePortalSession } from "../../../utils/franchiseSession";

export default function RestaurantPermissionGuard({ children }) {
  const location = useLocation();
  const franchisePortal = isFranchisePortalSession();

  // Franchise portal sessions are governed by FranchiseRouteGuard
  if (franchisePortal) {
    return children;
  }

  const isAllowed = canAccessPath(location.pathname);
  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
